import { getOSInfo } from 'utils/webDeviceInfo.utils';

/**
 * Detects iOS Safari mobile web (not Capacitor native).
 * @returns {boolean}
 */
export const isIOSSafariWeb = () => getOSInfo()?.name === 'iOS';

/**
 * Resolves a stable popover anchor element from a click event.
 * @param {React.MouseEvent} event
 * @returns {HTMLElement|null}
 */
export const resolveDatePickerAnchor = (event) => {
  if (!event?.currentTarget) return null;
  return (
    event.currentTarget.closest?.('.MuiOutlinedInput-root') ??
    event.currentTarget.closest?.('[data-date-picker-anchor]') ??
    event.currentTarget
  );
};

/**
 * Popper modifiers for date picker popovers.
 * iOS Safari: fixed strategy, no flip, opens below anchor.
 * @param {boolean} isIOSSafari
 * @returns {Array}
 */
export const getDatePickerPopperModifiers = (isIOSSafari) => {
  const modifiers = [
    {
      name: 'offset',
      options: { offset: [0, isIOSSafari ? 8 : 4] },
    },
    {
      name: 'preventOverflow',
      enabled: true,
      options: {
        padding: 8,
        altAxis: true,
        tether: true,
        rootBoundary: 'viewport',
      },
    },
  ];

  if (!isIOSSafari) {
    modifiers.unshift({
      name: 'flip',
      enabled: true,
      options: {
        fallbackPlacements: ['top-start', 'bottom-start'],
        padding: 8,
      },
    });
  }

  return modifiers;
};

/**
 * @param {boolean} isIOSSafari
 * @returns {'fixed'|'absolute'}
 */
export const getDatePickerPopperStrategy = (isIOSSafari) =>
  isIOSSafari ? 'fixed' : 'absolute';

/**
 * @param {boolean} isIOSSafari
 * @returns {string}
 */
export const getDatePickerMaxHeight = (isIOSSafari) =>
  isIOSSafari ? 'calc(100dvh - 16px)' : 'calc(100vh - 16px)';
